export const REDIRECTED_URL = 'AUTH/REDIRECTED_URL';
export const AUTHENTICATION = 'AUTH/check';
